export default "__VITE_ASSET__Piz7Vj8h__"